var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.83 390.47",
    style: {
      enableBackground: "new 0 0 456.83 390.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.24,265c0-58.91,0-117.82,0-176.73c0.27-8.33,4.06-14.71,10.78-19.46c4.84-3.42,10.33-4.98,16.15-4.99 c30.51-0.09,61.03-0.03,91.54-0.07c3.51,0,6.03,1.49,8.2,4.06c6.07,7.22,12.22,14.36,18.17,21.68c2.06,2.53,4.33,3.59,7.61,3.58 c36.98-0.09,73.95-0.07,110.93-0.05c9.85,0.01,17.94,3.67,23.76,11.81c3.45,4.82,4.95,10.34,4.96,16.16 c0.08,46.83,0.14,93.66-0.01,140.49c-0.05,16.22-12.95,27.51-27.72,27.47c-79.14-0.18-158.29-0.1-237.43-0.07 c-11.4,0-19.57-5.08-24.98-15.01C18.65,271.06,18.9,267.96,18.24,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.73,157.08c0,23.2,0.03,46.4-0.01,69.6c-0.03,13.18-7.92,23.54-19.85,26.56 c-2.56,0.65-3.19,0.29-3.19-2.44c0.08-43.01,0.08-86.02,0.05-129.03c-0.01-19.18-11.68-34.1-29.85-38.24 c-3.21-0.73-6.49-0.91-9.78-0.91c-35.7,0.02-71.4-0.01-107.1,0.06c-2.23,0-3.69-0.62-5.1-2.33c-5.36-6.56-10.99-12.9-16.27-19.52 c-4.16-5.23-9.36-7.45-15.99-7.42c-26.8,0.12-53.6,0.02-80.4,0.09c-2.59,0.01-3.48-0.25-2.67-3.24 c3.13-11.58,13.13-19.35,26.22-19.41c30.83-0.13,61.65-0.03,92.48-0.07c2.44,0,4.16,0.92,5.7,2.78 c6.69,8.07,13.53,16.02,20.17,24.12c1.43,1.74,2.89,2.34,5.1,2.34c37.29-0.06,74.58-0.03,111.86-0.06c6.62,0,12.8,1.28,18.16,5.44 c7.32,5.68,10.48,13.28,10.47,22.39C343.72,110.89,343.73,133.98,343.73,157.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.8c6018a174fe7feccab67fd9e44a0255.svg";
export { ForwardRef as ReactComponent };